// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"color-picker_wrapper__xbxtr","pickerWrapper":"color-picker_pickerWrapper__3PoSC","preview":"color-picker_preview__3x7Q6"};